var map = {
	"./Alert": 4,
	"./Alert.js": 4,
	"./CarbonAd": 12,
	"./CarbonAd.js": 12,
	"./Color": 6,
	"./Color.js": 6,
	"./Colors": 17,
	"./Colors.js": 17,
	"./Icons": 18,
	"./Icons.js": 18,
	"./Palette": 19,
	"./Palette.js": 19,
	"./PaletteDetails": 7,
	"./PaletteDetails.js": 7,
	"./PalettePreview": 9,
	"./PalettePreview.js": 9,
	"./TwitterShare": 8,
	"./TwitterShare.js": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;